

function createTable(queryDomElement, rows, columnNames, handlerCallback) {

    // the activity report uses these
    columnNames = columnNames||[];

    const table  = document.createElement("table");
    table.classList.add("small-stats-table");


    if (columnNames.length > 0) {
        table.classList.add("negative-th-margin");

        // add columns, if they were specified
        const thead = document.createElement("thead");
        const threadTr = document.createElement("tr")
        thead.appendChild(threadTr);

        for (let i = 0; i < columnNames.length; ++i) {
            const th = document.createElement("th")
            th.innerText = columnNames[i];
            threadTr.appendChild(th);
        }

        table.appendChild(thead);
    }




    const tableBody = document.createElement("tbody");

    for (let r=0;r<rows.length;++r) {
        const tr = document.createElement("tr");

        for (let c=0;c<rows[r].length;++c) {
            const td = document.createElement("td");
            if (typeof rows[r][c] == "number") {
                td.style.textAlign = "right";
                rows[r][c] = rows[r][c].toLocaleString();
            }
            td.innerHTML = rows[r][c];
            tr.appendChild(td);
        }

        tableBody.appendChild(tr);
    }

    table.appendChild(tableBody);

    let domTable = queryDomElement.parentNode.querySelector("table");
    if (domTable == null) {
        queryDomElement.parentNode.appendChild(table);
    } else {
        domTable.replaceWith(table);
    }


    if (handlerCallback)
        handlerCallback(table);
}

const Table = {
    "createTable": createTable
};

export default Table;